import React, { createContext, useEffect, useReducer } from 'react';

import MatxLoading from "../../components/MatxLoading";
import SessionOut from "../../views/sessions/SessionOut";
import useError from "../../hooks/useError";
import axios from '../../../axios';


const initialValue = {
    customers: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_CUSTOMER_DATA': {
            return {
                ...state,
                customer_list: action.payload,
            }
        }
        case 'UPDATE_CUSTOMER_DATA': {
            let newData = state.customer_list.customers.map((customer) =>
                action.payload.id === customer.id ? action.payload : customer
            );

            let newState = {
                customers: newData
            }

            return {
                ...state,
                customer_list: newState,
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const CustomerContext = createContext({
    customer_list: initialValue,
    getCustomers: () => { },
    changeStatus: () => { },
})

export const CustomerProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)
    const { setError } = useError();

    const getCustomers = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/customers/get_customers', options);

            dispatch({
                type: 'LOAD_CUSTOMER_DATA',
                payload: res.data,
            })
        } catch (e) {
            if (e?.response?.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e?.response?.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e?.response?.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
        }
    }

    const changeStatus = async (customer_id, status) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/customers/change_status_customer/' + customer_id + "/" + status, options);

            dispatch({
                type: 'UPDATE_CUSTOMER_DATA',
                payload: res.data,
            })
        } catch (e) {
            if (e.response.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })
            } else if (e.response.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
        }
    }

    useEffect(() => {
        getCustomers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if (state.status === 401) {
        return <SessionOut />
    }


    if (state.customer_list === undefined) {
        return <MatxLoading />
    }

    return (
        <CustomerContext.Provider
            value={{
                customer_list: state.customer_list,
                getCustomers,
                changeStatus
            }}
        >
            {children}
        </CustomerContext.Provider>
    )
}

export default CustomerContext
